import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

// Helper limpio (URL bien formada con '/api/...') para selectores que solo
// necesitan { Id, nombre, apellidos, mail_empresa } de personas colaboradoras
// activas. Convive con fetchPersonasColaboradorasData.
export const fetchColaboradoresParaSelector = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/personas-colaboradoras`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` },
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Fase 4 · candidatos a supervisor de una colaboradora, para el selector de su ficha.
//
// NO vale fetchPersonasColaboradorasData: ése devuelve TODAS las activas de TODAS las
// empresas y sin mirar si el módulo de vacaciones está activo. Este endpoint reutiliza en
// servidor `colabPersonasDe`, la misma función que usa la derivación del ámbito, así que no
// puede ofrecer a nadie que el servidor vaya a rechazar al guardar.
export const fetchCandidatosSupervisorColab = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/vacaciones/supervisores-colab/candidatos/${id}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` },
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchPersonasColaboradorasData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/personas-colaboradoras`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchPersonaColaboradoraData = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/persona-colaboradora/${id}`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

/* ── `activo` YA NO VALE `true` POR DEFECTO, Y ES UN SUELO QUE SOBREVIVIO A SU CAUSA ──────────
 *
 * Este defecto reflejaba el del SERVIDOR, que empezaba con `whereCondition = { activo: true }`.
 * **La Fase D levanto ese suelo en el servidor y este se quedo aqui**, en una firma, donde nadie
 * lo buscaba: el `where` ya no filtraba, pero el cliente seguia pidiendo que filtrara.
 *
 * El 01/10 costo medio dia. Ocho colaboradores creados con fecha de alta futura nacen «En Proceso»
 * y `activo = 0`; la pestana de colaboradoras llama a esta funcion SIN el argumento 11, asi que
 * mandaba `activo: true` y los ocho eran invisibles — tambien con el filtro de estado puesto.
 *
 * Su hermana —la de usuarios no administradores— ya valia `null`. **Dos funciones con la misma
 * firma y defectos distintos para el mismo argumento**: la que filtraba era justo la de quien mas
 * mira el listado.
 *
 * Se iguala a `null` = «no filtres por activo». Quien quiera filtrar, que lo pida. */
/*
 * LA FIRMA ES LA MISMA QUE LA DE `fetchPersonasFiltersAdminData`, A PROPOSITO.
 *
 * Las dos tenían la misma intención y DISTINTA lista de argumentos: `ventana` era el 12º aquí y
 * el 14º allí. La pantalla llamaba a las dos desde el mismo sitio y la rama de colaboradores
 * cortaba en el 11º, así que **`ventana` no viajaba**: el servidor no recibía la llave de la
 * puerta y las columnas de contraseña llegaban vacías. Las columnas SÍ estaban en la cabecera
 * —no depende de la pestaña—, y por eso se percibía como «no salen».
 *
 * Pasar un argumento más lo habría arreglado y habría dejado la trampa intacta. Dos listas
 * posicionales que deben coincidir y nada las obliga es la misma forma que insertar una llamada
 * en medio de un `Promise.all`: nada falla, llega otra cosa.
 *
 * `colaboradores`, `segundoFactor` y `empresaContratante` NO se usan aquí, y se aceptan igual
 * para que la llamada pueda ser UNA. Comprobado antes de converger que el endpoint de
 * colaboradoras no los lee para nada: desestructura campos con nombre
 * (`items_per_page, current_page, order, filteredWord, rol, estado, negocio, activo`), sin spread
 * ni `where` dinámico, así que lo que no nombra se ignora. Si algún día los leyera, convergir
 * las firmas los activaría sin querer — por eso queda dicho aquí.
 */
export const fetchPersonasColaboradorasFiltersAdminData = async (paginaActual, registrosPorPag, rol, estado, departamento, negocio, busqueda, ordenarColumna, orden, mostrarDependientes = false, activo = null, colaboradores = false, segundoFactor = null, ventana = null, empresaContratante = null) => {
    try {
        const response = await axios.post(`${API_URL}/api/personas-colaboradoras/adminfilters`, {
            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "rol": rol,
            "estado": estado,
            "negocio": negocio,
            "activo": activo,
            "ventana": ventana,   // Fase A1 · sin ella, el listado NO trae secretos
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }
        }, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchPersonasColaboradorasFiltersData = async (paginaActual, registrosPorPag, rol, estado, departamento, negocio, busqueda, ordenarColumna, orden, mostrarDependientes = false, activo = null) => {
    try {
        const response = await axios.post(`${API_URL}/api/personas-colaboradoras/filters`, {
            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "rol": rol,
            "estado": estado,
            "negocio": negocio,
            "activo": activo,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }
        }, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearPersonaColaboradora = async (formData) => {
    try {
        if (formData.imagenPersona_img) {
            const file = formData.imagenPersona_img;
            const base64Image = await convertToBase64(file);
            formData.imagen_base64 = base64Image;
            delete formData.imagenPersona_img;
        }

        const response = await axios.post(`${API_URL}/api/persona-colaboradora`, formData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEditarPersonaColaboradora = async (personaData) => {
    try {
        if (personaData.imagenPersona_img) {
            const file = personaData.imagenPersona_img;
            const base64Image = await convertToBase64(file);
            personaData.imagen_base64 = base64Image;
            delete personaData.imagenPersona_img;
        }

        const response = await axios.put(`${API_URL}/api/editarPersonaColaboradora/${personaData.Id}`, personaData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};

export const fetchEliminarPersonaColaboradora = async (ids) => {
    try {
        const response = await axios.post(`${API_URL}/api/persona-colaboradora/eliminar`, {
            ids: ids
        }, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

/** El gemelo: suspender o levantar colaboradoras en grupo. Mismo contrato. */
export const fetchSuspensionPersonasColaboradoras = async (ids, suspender) => {
    try {
        const response = await axios.post(`${API_URL}/api/personas-colaboradoras/suspension`,
            { ids, suspender },
            { headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` } });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
